import { UpdateOrgUserVCSUserNameRequest, tryUpdateOrgSettings } from '@/actions/orgSettings';
import { OrgSettingsUpdatable } from '@/actions/updatable';
import { IntegrationProviderId } from '@/types';
import { globalMessage } from '@/utils/globalMessage';
import { Form, Input, Modal } from 'antd/lib';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useError, useIsLoading, useUpdated } from '@/utils/hooks/helpers';

interface EditVCSUserNameModalProps {
    open: boolean;
    onCancel: () => void;
    orgId: string;
    userId: string;
    vcsUserName: string;
    vcsProviderId: IntegrationProviderId;
    vcsName: string;
}

const EditVCSUserNameModal: React.FC<EditVCSUserNameModalProps> = (props: EditVCSUserNameModalProps) => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();

    const editVCSUserName = (value) => {
        const request: UpdateOrgUserVCSUserNameRequest = {
            userId: props.userId,
            vcsUserName: value['vcsUserName'],
            vcsProviderId: props.vcsProviderId,
            orgId: props.orgId,
        };
        dispatch(tryUpdateOrgSettings(OrgSettingsUpdatable.UpdateVCSUserNameForOrgUser, request));
    };

    const updateVCSUserNameIsLoading = useIsLoading(OrgSettingsUpdatable.UpdateVCSUserNameForOrgUser);
    const updateVCSUserNameSuccess = useUpdated(OrgSettingsUpdatable.UpdateVCSUserNameForOrgUser);
    const updateVCSUserNameError = useError(OrgSettingsUpdatable.UpdateVCSUserNameForOrgUser);

    React.useEffect(() => {
        if (updateVCSUserNameSuccess) {
            globalMessage.success(`${props.vcsName} user name updated successfully`);
            props.onCancel();
        }
    }, [updateVCSUserNameSuccess]);

    React.useEffect(() => {
        if (updateVCSUserNameError) {
            globalMessage.error(updateVCSUserNameError);
        }
    }, [updateVCSUserNameError]);

    const initialValues = {
        vcsUserName: props.vcsUserName,
    };

    return (
        <Modal
            title={`Edit ${props.vcsName} user name`}
            onOk={form.submit}
            okButtonProps={{ loading: updateVCSUserNameIsLoading }}
            okText="Save"
            open={props.open}
            onCancel={props.onCancel}
            afterClose={form.resetFields}
        >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <Form
                    onFinish={editVCSUserName}
                    initialValues={initialValues}
                    style={{ marginTop: 24, width: '100%' }}
                    form={form}
                    layout="vertical"
                >
                    <Form.Item
                        name="vcsUserName"
                        required={true}
                        help={`Provide your ${props.vcsName} user name in case Runway hasn't been able to infer it.`}
                    >
                        <Input placeholder={`${props.vcsName} user name`} />
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    );
};

export default EditVCSUserNameModal;
